import { fetchConfig } from './HttpClient';

/**
 * HTTP client for the embedded document viewer.
 * Uses Authorization: ViewerToken {token} instead of Bearer tokens.
 * Does not append clientId — tenant context is derived from the token prefix server-side.
 */

function addViewerTokenHeader(options: RequestInit, viewerToken: string): RequestInit {
  return {
    ...options,
    headers: {
      Accept: 'application/json',
      Authorization: `ViewerToken ${viewerToken}`,
      ...(options.headers || {}),
    },
  };
}

export const viewerHttpGet = async (url: string, viewerToken: string): Promise<Response> => {
  const config = await fetchConfig();
  const fullUrl = `${config.api_endpoint}/${url}`;
  return fetch(fullUrl, addViewerTokenHeader({ method: 'GET' }, viewerToken));
};

export const viewerHttpGetFile = async (url: string, viewerToken: string): Promise<Response> => {
  const config = await fetchConfig();
  const fullUrl = `${config.api_endpoint}/${url}`;
  return fetch(fullUrl, {
    method: 'GET',
    headers: {
      Authorization: `ViewerToken ${viewerToken}`,
    },
  });
};

export const viewerHttpPostFormData = async (
  url: string,
  viewerToken: string,
  body: FormData
): Promise<Response> => {
  const config = await fetchConfig();
  const fullUrl = `${config.api_endpoint}/${url}`;
  // Don't set Content-Type for FormData — browser sets it with boundary
  return fetch(fullUrl, {
    method: 'POST',
    headers: {
      Authorization: `ViewerToken ${viewerToken}`,
    },
    body,
  });
};
